import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { CONTACT_TELEGRAM, CONTACT_WHATSAPP } from "@/components/BriefFormDialog";
import { useT } from "@/i18n/LanguageContext";

const pillStyle = {
  background: "linear-gradient(135deg, rgba(18,18,20,0.95) 0%, rgba(38,38,42,0.92) 100%)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,255,255,0.12)",
  backdropFilter: "blur(10px)",
} as const;

export const TelegramButton = () => {
  const t = useT();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let heroHeight = window.innerHeight;
    let ticking = false;

    const handleResize = () => {
      requestAnimationFrame(() => {
        heroHeight = window.innerHeight;
      });
    };

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setIsVisible(window.scrollY > heroHeight * 0.9);
        ticking = false;
      });
    };

    window.addEventListener("resize", handleResize, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed bottom-4 right-4 z-50 flex items-center gap-2",
        "transition-all duration-500 ease-out",
        "md:bottom-8 md:right-8 md:gap-2.5",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      )}
    >
      <a
        href={CONTACT_WHATSAPP}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("Написать в WhatsApp")}
        className="flex items-center justify-center rounded-full w-10 h-10 md:w-12 md:h-12 transition-transform duration-300 hover:scale-105 active:scale-95"
        style={pillStyle}
      >
        <svg className="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.174.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.988 2.896 9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.886-9.885 9.886m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.548 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0 0 20.464 3.488" />
        </svg>
      </a>

      <a
        href={CONTACT_TELEGRAM}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("Написать в Telegram")}
        className="flex items-center gap-2 rounded-full px-3 py-2 md:px-5 md:py-3 transition-transform duration-300 hover:scale-[1.03] active:scale-95"
        style={pillStyle}
      >
        <svg className="w-4 h-4 md:w-5 md:h-5 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>
        <span className="text-white text-[12px] md:text-[14px] font-medium whitespace-nowrap">{t("Связаться")}</span>
      </a>
    </div>
  );
};
